import { PayloadAction } from '@reduxjs/toolkit';

import { FontState, FontStatus } from 'editor/src/store/fonts/types';

const updateFontStatusReducer = (
  state: FontState,
  action: PayloadAction<{ fontFile: string; fontStatus: FontStatus }>,
) => {
  const { fontFile, fontStatus } = action.payload;
  const font = state.availableFonts.find((f) => f.metadata.fontFile === fontFile);
  if (font) {
    font.status = fontStatus;
    return;
  }

  // For uploaded fonts, store status directly on the font object
  const uploadedFont = state.uploadedFonts.find((f) => f.fontFile === fontFile);
  if (uploadedFont) {
    uploadedFont.loadingStatus = fontStatus;
  }
};

export default updateFontStatusReducer;
